import {combineReducers} from 'redux'
import { addData } from './reducer'

const rootReducer = combineReducers({addData})

export default rootReducer;